function getNested(obj, path) {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
}

export function t(key, vars = {}) {
    if (!window.bwLang) {
        console.warn('Translations not loaded in bwData');
        return key;
    }

    // let str = window.bwData.translations[key] || key;
    let str = getNested(window.bwLang, key) || key;

    for (const [k, v] of Object.entries(vars)) {
        str = str.replace(new RegExp(`:${k}`, 'g'), v);
    }

    return str;
}
